<template>
  <ul class="accordion" data-accordion data-multi-expand="true" data-allow-all-closed="true">
    <li class="accordion-item" data-accordion-item v-for="(item, key) in items" :key="`accordion-item-${key}`" ref="accordion-item-key">
      <a href="#" class="accordion-title" v-if="item.title">
        <div class="accordion-title-inner">
          <span class="accordion-counter">{{ key + 1 }}</span>
          {{ item.title }}
        </div>
      </a>
      <div class="accordion-content" data-tab-content v-if="item.content" v-html="item.content"/>
    </li>
  </ul>
</template>
<script>
import foundation from '@/mixins/foundation.js'

export default {
  name: 'Accordion',
  props: {
    items: {
      type: Array,
      default() {
        return []
      }
    }
  },
  mixins: [foundation]
}
</script>
<style lang="scss">
ul.accordion {
  li.accordion-item {
    a.accordion-title {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      font-weight: bold;
      font-size: 1rem;
      color: #2B2E34;
      border: unset;

      &:not(:first-child) {
        border-top: 1px solid $light-gray;
      }

      &:not(:last-child) {
        border-bottom: 1px solid $light-gray;
      }

      .accordion-title-inner {
        line-height: 1.3;
        .accordion-counter {
          font-size: 1.8rem;
          display: block;
          margin-bottom: 0.5rem;
        }
      }

      &:after {
        content: '\f078';
        font-family: 'Font Awesome 5 Pro';
        font-weight: bold;
        margin-top: 2.2rem;
        font-size: 1.5rem;
      }
    }

    &.is-active {
      background: $light-gray;

      a.accordion-title {
        &:after {
          content: '\f077';
        }
      }
    }
  }
}
</style>
